import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const SeasonCtx = createContext(null);

export function SeasonProvider({ children }) {
  const [activeSeason, setActiveSeason] = useState(null);
  const [seasons, setSeasons] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setActiveSeason(data.active_season);
      setSeasons(data.seasons || []);
    } catch { /* public ok */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const changeSeason = async (season) => {
    const { data } = await api.put("/settings/active-season", { season });
    setActiveSeason(data.active_season);
    setSeasons(data.seasons || []);
    return data;
  };

  const startNewSeason = async (season, archiveSeniors = true) => {
    const { data } = await api.post("/settings/start-new-season", { season, archive_seniors: archiveSeniors });
    setActiveSeason(data.active_season);
    setSeasons(data.seasons || []);
    return data;
  };

  return (
    <SeasonCtx.Provider value={{ activeSeason, seasons, refresh, changeSeason, startNewSeason }}>
      {children}
    </SeasonCtx.Provider>
  );
}

export const useSeason = () => useContext(SeasonCtx);
